import { createStore } from 'vuex'
import axios from 'axios'

export default createStore({
  state: {
    articles: []
  },
  mutations: {
    SAVE_DATA (state, data) {
      // state.articles = data.articles;
      state.general = data.general;
      state.mapStatus = data.status;

      state.totaalgemeenten = data.totaal.totaal;
      state.onderzoek = data.totaal.totaal_onderzoek;
      state.afgerond = data.totaal.afgerond;
    }, 
  },
  actions: {
    loadData ({ commit, state }) {
      return new Promise((resolve, reject) => { 
        axios
          .get(process.env.VUE_APP_API)
          .then(result => {
            commit("SAVE_DATA", result.data);
            resolve();
          })
          .catch(error => {
            reject();
            throw new Error(`API ${error}`);
          });
      })
    },    
  },
  modules: {

  }
})
